var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1183_2483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.54016 16.4598C2.82934 15.4707 5.81576 14.3711 8.99998 14.3711C12.1842 14.3711 15.1706 15.4707 16.4598 16.4598",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.15967 7.16646C1.60662 5.89096 1.06404 3.14444 2.00207 1.83504C3.40878 1.05043 6.07674 1.89884 7.16922 3.58565C8.08702 5.00274 7.53915 6.12037 6.58788 6.96992C5.63063 7.82482 4.4644 8.238 3.15967 7.16646Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21448 14.3711C9.40098 10.9582 8.49347 8.32049 5.18555 5.27197",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20514 14.3618C9.70868 12.0306 10.7135 9.20856 12.1937 7.64926",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9077 4.87585C12.8693 3.56613 15.0629 3.0077 16.1611 3.70759C16.8562 4.80884 16.2882 6.99991 14.9743 7.95585C13.8705 8.75892 12.9441 8.3656 12.2167 7.63486C11.4845 6.89954 11.0998 5.97613 11.9077 4.87585Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1183_2483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfDevelopment);
export default __webpack_public_path__ + "static/media/self_development.872276c94e6de5e809f21ddf748737cf.svg";
export { ForwardRef as ReactComponent };